import countryNoneList from './contry-none';
import continentsNoneList from './continents-none';
import timeContinentsList from './time-continents';

export default [...countryNoneList, ...continentsNoneList, ...timeContinentsList, ];